import React from "react"

import Instructor from "./instructor"
import Review from "./review"

const Author = ({ article }) => {
  const { elements, authors, reviewers, instructorClass } = article
  const author = authors && authors[0]
  if (!author) {
    return null
  }
  const reviewer = reviewers && reviewers[0]
  const hasReview = elements?.some(({ type }) => type === "review")
  if (hasReview) {
    return <Review author={author} reviewer={reviewer} />
  }

  if (instructorClass) {
    return <Instructor author={author} instructorClass={instructorClass} />
  }
}

export default React.memo(Author)
